module.exports = __webpack_public_path__ + "static/media/Ground.438b1dc7.svg";